export default __webpack_public_path__ + "static/media/img8.8d32ded6.png";